import {
  getRegisteredProductBySlug
} from "./chunk-6UZ4MMYO.js";

// src/primary-nav-from-registry.ts
function primaryNavLinksForSlug(slug) {
  const def = getRegisteredProductBySlug(slug);
  return def?.nav?.length ? def.nav : void 0;
}

export {
  primaryNavLinksForSlug
};
